import { makeEnvironmentProviders } from '@angular/core';
import { ChatService, ChatStore } from '@coin/chat-bot-data-access';
import { provideMarkdown } from 'ngx-markdown';

export function provideChatBot() {
  return makeEnvironmentProviders([provideMarkdown({}), ChatService, ChatStore]);
}
